export const location = [
  {
    label: 'India',
    value: 'India',
  },
  {
    label: 'US',
    value: 'US',
  },
];

export enum VendorInvite {
VendorInvitationForm = 'Vendor Invitation Form',
  OrganizationDetails = 'Organization Details',
  OrganizationName = 'Name of the Organization*',
  OrganizationLocation = 'Location of the Organization*',
  OrganizationAddress = 'Address*',
  Poc = 'Point of Contact (POC) Details',
  PocName = 'Name of POC*',
  PocContact = 'Contact Number of POC*',
  PocDesignation = 'Designation of POC*',
  PocEmail = 'Email of POC*',
  UploadDocuments = 'Upload Documents for Digital Signature',
  FileSelect = 'Select file(s) or drop here to upload',
  FileFormat = 'JPEG, PNG, PDF and MP4 formats, up to 50 MB.',
  BrowseFile = 'Browse file',
  Cancel = 'Cancel',
  Submit = 'Submit',
  Error = 'Error',
  Success = 'Success',
}

export enum FormErrorKey {
  Required = 'required',
  Email = 'email',
  OnlyZeros = 'onlyZeros',
}

export enum FormErrorMessage {
  Required = 'This field is required.',
  Email = 'Invalid email format.',
  OnlyZeros = 'Contact number cannot be all zeroes.',
  FileSize = 'Total file size exceeds 50MB.',
  NoFile = 'Please upload at least one document.',
  InvalidForm = 'Form is invalid',
  Success = 'Invitation sent!',
}
